

import { computed, defineComponent, onMounted, ref, watch, Component } from 'vue';
import { Container } from 'inversify';
import { useI18n } from 'vue-i18n';
import { messages } from './localization/MessagesBusqueda'
import { IapCatalog } from '../../../catalog/domain/iapCatalog';
import { SearchData } from '../../../search/domain/search';
import { IapDataSourceTableAlias } from '../../../datasource/domain/iapDataSourceTableAlias';
import DataSourceComp from '../functions/dataSourceComp';
import FiltroBusquedaConst from '../../../../../common/domain/constantes/FiltroBusquedaConst';
import CatalogTypeConst from '../../../../../common/domain/constantes/CatalogTypeConst';
import SqlTypesConst from '../../../../../common/domain/constantes/SqlTypesConst';
import { IServiceSearch } from '../../../search/application/IServiceSearch';
import { TYPES } from '../../../../../common/domain/types';
import HelperLoading from '../../../../../common/infrastructure/funciones/HelperLoading';
import SplitButton from 'primevue/splitbutton';
import Menu from 'primevue/menu';
import { MenuItem } from 'primevue/menuitem';
import { IapDataSourceField } from '../../../datasource/domain/iapDataSourceField';
import { IapComponentDataSource } from '../../../component/domain/iapComponentDataSource';
import SaveSearch from './SaveSearch.vue'
import { IampSearchConfig } from '@ilinium/shared/src/entidades/builderMaster/user/domain/iampSearchConfig';
import DataSourceConst from '../functions/dataSourceConst';
import HelperUtils from '../../../../../common/infrastructure/funciones/HelperUtils';
import { useStore } from 'vuex';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';

export default defineComponent({
    name: 'search',
    props: {
        container: {
            type: Object as () => Container
        },
        applicationId: {
            type: Number,
            default: -1
        },

        applicationVersion: {
            type: Number,
            default: -1
        },
        componentId: {
            type: Number,
            default: -1
        },
        modelValue: {
            type: Object as () => Partial<SearchData>[],
            default: () => ([])
        },
        dataSearch: {
            type: Object as () => any,
            default: () => ([])
        },
        compDataSource: {
            type: Object as () => IapComponentDataSource,
            default: () => ({})
        },
        catalogosData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },
        showBtnSearch: {
            type: Boolean,
            default: true
        },
        showBtnClear: {
            type: Boolean,
            default: true
        },
        showBtnCloseTabs: {
            type: Boolean,
            default: false
        },
        showBtnSaveSearch: {
            type: Boolean,
            default: true
        },
        maxRegs: {
            type: Number,
            default: 100
        },


    },
    emits: ['update:modelValue', 'update:catalogosData', 'update:dataSearch', 'closealltabs','buscarDatos'],
    components: {

        SaveSearch

    },
    setup(props, { emit }) {
        const { t, locale } = useI18n(messages)
        const store = useStore();
        const { catalogos, dataFilter, isType, isCatalogType, existeCampoFiltrado,
            isFilterVisible,
            getCatalogData,
            generateFormatCol,
            dataSearchResult,
            tablas,
            tablasData,
            dataBaseId,
        } = DataSourceComp(props.container as any, props, emit, t,props.compDataSource,props.catalogosData,store)



        //const tableNames = ['Identidad', 'Recibo', 'Poliza', 'Riesgo', 'Suplemento', 'Siniestro']        
        //const dataFilter = ref<Partial<busquedaGestion>[]>([]);
        const visibleFindTable = ref(false);
        const selectedSearch = ref('');
        const menuFilter = ref();
        const opSaveSearch = ref();
        let savedSearchs = ref([{ label: 'Búsqueda 1' }, { label: 'Búsqueda 2' }]);

        watch(locale, () => {

        });





       
        const getData = computed(() => {


            var data = [] as any;


            if (tablasData.value.length > 0) {
                tablas.value.forEach(x => {
                    const aux = {
                        label: x.shortDescription,
                        icon: x.idIcon ?? 'pi pi-list',
                        code: x.tableName,
                        items: tablasData.value.filter(t => t.dataSourceTableAliasId != null &&  t.tableName == x.tableName && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == t.id)?.filterSearch && !existeCampoFiltrado(t)).sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterSearchOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterSearchOrder ?? 0); }).map(t => ({
                            label: (t.shortDescription ?? t.field), tabla: t.tableName, value: t.tableName + DataSourceConst.DELIMITER + t.field, disabled: false,
                            command: (event: any) => {
                                selectedSearch.value = event.item.value
                                selectQuestion(event)
                                // event.originalEvent: Browser event
                                // event.item: Menuitem instance
                            }
                        })),
                        visible: tablasData.value.filter(t => t.tableName == x.tableName && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == t.id)?.filterSearch && !existeCampoFiltrado(t)).length > 0

                    }
                   
                    data.push(aux);
                })
            }

            
            const auxCustom = {
                        label: 'Calculados',
                        icon: 'pi pi-list',
                        code:DataSourceConst.AGGREGATE_TABLE,
                        items: tablasData.value.filter(t => t.dataSourceTableAliasId == null && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == t.id)?.filterSearch && !existeCampoFiltrado(t)).sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.filterSearchOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.filterSearchOrder ?? 0); }).map(t => ({
                            label: (t.shortDescription ?? t.fieldAlias), tabla: t.tableName, value: t.tableName + DataSourceConst.DELIMITER + t.fieldAlias, disabled: false,
                            command: (event: any) => {
                                selectedSearch.value = event.item.value
                                selectQuestion(event)
                                // event.originalEvent: Browser event
                                // event.item: Menuitem instance
                            }
                        })),
                        visible: tablasData.value.filter(t => t.dataSourceTableAliasId == null && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == t.id)?.filterSearch && !existeCampoFiltrado(t)).length > 0

                    }

            if (auxCustom.items.length>0)        {
                data.push(auxCustom);
            }

            return data;
        })


        const initData = () => {
            
            if (dataFilter.value && dataFilter.value.length == 0) {
                //const campos = ['NombreCompleto', 'NumDocumento']                
                const firstTabla = tablas.value[0]?.tableName ?? ''
                tablasData.value.filter(x => x.tableName.toLocaleLowerCase() == firstTabla.toLocaleLowerCase() && props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == x.id)?.defaultFilterSearch)
                    .sort((a, b) => { return (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == a.id)?.defaultFilterSearchOrder ?? 0) - (props.compDataSource.iapComponentDataSourceFieldConfigurations.find(z => z.dataSourceFieldId == b.id)?.defaultFilterSearchOrder ?? 0); })
                    .forEach(c => {
                        dataFilter.value.push({
                            field: c as any,
                            rangeDateTime: {
                                from: null,
                                to: null
                            },
                            rangeValue: {
                                from: null,
                                to: null
                            },
                            filter: FiltroBusquedaConst.FILTROBUSQUEDA_CONTIENE,
                            //tableName:props.tablas.find(x=> x.tableName == c.tableName)?.tableAlias ?? props.tablas.find(x=> x.tableName == c.tableName)?.tableName,
                            //tableIcon: props.tablas.find(x=> x.tableName == c.tableName)?.idIcon ?? 'pi pi-list',
                        } as any)
                    })
            }

        }



        const selectQuestion = (event: any) => {

            const aux = selectedSearch.value.split(DataSourceConst.DELIMITER)
            
            tablasData.value.filter(x => x.tableName == aux[0] && (x.field == aux[1] || x.fieldAlias == aux[1])).forEach(c => {
                dataFilter.value.push({
                    field: c as any,
                    rangeDateTime: {
                        from: null,
                        to: null
                    },
                    rangeValue: {
                        from: null,
                        to: null
                    },
                    filter: FiltroBusquedaConst.FILTROBUSQUEDA_CONTIENE
                } as any)
            })

            selectedSearch.value = ''
        }


        const removeQuestion = (data: IapDataSourceField) => {

            dataFilter.value = dataFilter.value.filter(x => x.field.id !== data.id)
        }

        const clearFilterData = () => {
            if (dataFilter.value.length == 0) {
                initData()
            }
            else {
                dataFilter.value.forEach(x => {
                    x.value = '',
                        x.rangeDateTime = {
                            from: null,
                            to: null
                        },
                        x.filter = '',
                        x.rangeNumber = {
                            from: null,
                            to: null
                        },
                        x.rangeValue = {
                            from: null,
                            to: null
                        },
                        x.valueBool = undefined,
                        x.valueDateTime = undefined,
                        x.valueList = undefined,
                        x.valueNumber = undefined

                })
            }


        }

        const showMenuFilter = (event: any) => {
            menuFilter.value.show(event);
        };

        const openSaveSearch = (event: any) => {
            opSaveSearch.value.toggle(event);

        }

        const loadSearch = (data: IampSearchConfig) => {            
            const savedData = JSON.parse(data.data) as any
            HelperUtils.handleDates(savedData)
            if (savedData.length > 0) {


                opSaveSearch.value.hide();
                HelperLoading.showLoading();
                dataFilter.value.length = 0

                savedData.forEach(item => {
                    const _field = props.compDataSource.dataSource.iapDataSourceFields.find(x => x.id == item.fieldId)
                    if (_field) {


                        dataFilter.value.push({
                            field: _field as any,
                            filter: item.filter as any,
                            value: item.value,
                            valueList: item.valueList as any,
                            valueBool: item.valueBool as any,
                            valueNumber: item.valueNumber as any,
                            valueDateTime: item.valueDateTime, rangeValue: item.rangeValue, rangeNumber: item.rangeNumber,
                            rangeDateTime: item.rangeDateTime

                        } as any)
                    }
                });
                if (dataFilter.value.length > 0) {
                    emit('buscarDatos');                    
                }
                else {
                    HelperLoading.hideLoading();
                }

            }



        }

        const getDataContext = computed(() => {
            return getData.value
        })

        const translateFieldLabel = (item:any) =>{
            
            if (!HelperCommon.isNullOrWhitespace(item.field?.shortDescription))
            {
                return item.field?.shortDescription;
            }
            else if (!HelperCommon.isNullOrWhitespace(item.field?.fieldAlias)){
                return item.field?.fieldAlias;
            }
            

            return item.field?.field;
        }

        onMounted(() => {
            //getTables();  
            initData()
            //Catalog(CatalogTypeConst.FILTROBUSQUEDA)          
        });




        return {
            t,
            locale,
            visibleFindTable,
            selectedSearch,
            getData,
            existeCampoFiltrado,
            dataFilter,
            selectQuestion,
            removeQuestion,
            clearFilterData,
            SqlTypesConst,
            isType,
            isCatalogType,
            getCatalogData,
            catalogos,
            isFilterVisible,
            CatalogTypeConst,            
            dataSearchResult,
            menuFilter,
            showMenuFilter,
            getDataContext,
            savedSearchs,
            tablas,
            tablasData,
            dataBaseId,
            opSaveSearch,
            openSaveSearch,
            loadSearch,
            translateFieldLabel
        };
    },
});
